export const createHistoryAdapter = () => {
  const getState = () => {
    const state = window.history.state as unknown
    return state && typeof state === 'object'
      ? (state as Record<string, unknown>)
      : {}
  }

  return {
    getLocation: () => window.location,
    getState,
    replaceState: (nextState: Record<string, unknown>, nextPath: string) =>
      window.history.replaceState(nextState, '', nextPath),
    pushState: (nextState: Record<string, unknown>, nextPath: string) =>
      window.history.pushState(nextState, '', nextPath),
    go: (delta: number) => window.history.go(delta),
    addPopStateListener: (handler: (event: PopStateEvent) => void) =>
      window.addEventListener('popstate', handler),
    removePopStateListener: (handler: (event: PopStateEvent) => void) =>
      window.removeEventListener('popstate', handler),
  }
}
